module.exports = __webpack_public_path__ + "public/Icons/Language-white.svg?0a378a49";